import React, { useState, useEffect, useCallback } from 'react';

import {LocationsList} from "./Location"
import {SearchForm} from "./SearchBar";
import {MapList} from "./Map";
import "./styles.css"
import queryString from 'query-string'

const apiUrl = 'https://locator.dualsidedapp.com'

export const TYPE = {
    MAP: 'map',
    LIST: 'list',
}

export const Complete = ({shop, designated, onDesignate, type = TYPE.LIST, renderCallback, searchParams = {}}) => {
    const [search, setSearch] = useState({current: searchParams})
    const [designatedId, setDesignatedId] = useState(designated)
    const [products, setProducts] = useState([])
    const [results, setResults] = useState([])
    const [searching, setSearching] = useState(false)
    const [searched, setSearched] = useState(false)

    useEffect(() => {
        fetch(`${apiUrl}/api/products?`+new URLSearchParams({shop}))
            .then((response) => response.json())
            .then((data) => {
                setProducts(data)
            })
    }, [shop])

    const onSubmit = (vals) => {
        if (!vals.radius) {
            vals.radius = 15 // todo
        }
        vals.v2 = true
        search.current = vals
        setSearched(true)
        setSearching(true)
        const params = {...vals, shop}
        return fetch(`${apiUrl}/locations?`+queryString.stringify(params, {arrayFormat: 'bracket'}))
            .then((response) => response.json())
            .then((data) => {
                if (data.message) {
                    setResults([])
                    throw new Error(data.message) // todo too loud?
                }
                setResults(data.results.filter(el => {
                    return el.latitude !== null
                }))
            })
            .finally(() => {
                setSearching(false)
            })
    }

    const myRenderCallback = useCallback((el) => {
        if (!el) {
            return
        }

        // expose an API on element
        el.search = function(search) {
            search.current = search
            onSubmit(search)
        }

        // consider supporting this without jquery
        el.searchParams = function() {
            return search.current
        }

        if (renderCallback) {
            renderCallback(el)
        }
    }, [renderCallback])

    const myOnDesignate = (id) => {
        if (onDesignate) {
            onDesignate(id)
        }
        setDesignatedId(id)
    }

    return <div ref={myRenderCallback}>
        <SearchForm location={searchParams?.location} onSubmit={onSubmit} products={products} />

        {!searched && <p className="ds-placeholder">Please enter a city or zip code above to search.</p>}

        {searching && <SearchingIndicator />}

        {searched && !searching && <p className="ds-location-count">
            {results.length + ' locations found' }
        </p>}

        {searched && type === TYPE.LIST && <LocationsList
            locations={results.map(res => res.location)}
            designatedId={designatedId}
            onDesignate={myOnDesignate}
        />}
        {searched && type === TYPE.MAP && <MapList
            locations={results}
            designatedId={designatedId}
            onDesignate={myOnDesignate}
        />}
    </div>
}

const SearchingIndicator = () => <p className="ds-placeholder">Searching...</p>

// todo proptypes